export default "__VITE_ASSET__3515f571__"